import { Badge } from "@shared/ui/badge";
import { Button } from "@shared/ui/button";
import { Mail, Phone, User, X } from "lucide-react";
import React from "react";

interface SelectedConsumerCardProps {
  consumer: any;
  onRemove: () => void;
  currency: string;
}

export const SelectedConsumerCard: React.FC<SelectedConsumerCardProps> = ({
  consumer,
  onRemove,
  currency,
}) => {
  const getStatusClassName = (status: any["status"]) => {
    return status === "Active"
      ? "bg-green-100 text-green-800 hover:bg-green-100"
      : "bg-red-100 text-red-800 hover:bg-red-100";
  };

  const statusBadge = (status: string) => {
    console.log("status", status);
    if (status === "ACTIVE")
      return (
        <span className="bg-green-100 text-green-700 px-2 py-1 rounded text-xs font-medium">
          Active
        </span>
      );
    if (status === "INACTIVE")
      return (
        <span className="bg-red-100 text-red-700 px-2 py-1 rounded text-xs font-medium">
          Inactive
        </span>
      );
    if (status === "PENDING")
      return (
        <span className="bg-yellow-100 text-yellow-800 px-2 py-1 rounded text-xs font-medium">
          Pending
        </span>
      );
    if (status === "DISCONNECTED")
      return (
        <span className="bg-gray-100 text-gray-800 px-2 py-1 rounded text-xs font-medium">
          Disconnected
        </span>
      );
    return (
      <span className="bg-gray-100 text-gray-800 px-2 py-1 rounded text-xs font-medium">
        {status}
      </span>
    );
  };

  return (
    <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
      <div className="flex items-start gap-3">
        {/* User Icon */}
        <div className="flex-shrink-0">
          <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center">
            <User className="w-6 h-6 text-blue-600" />
          </div>
        </div>

        {/* Consumer Info */}
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <h3 className="font-semibold text-gray-900">
              {consumer?.firstName + " " + consumer?.lastName}
            </h3>

            {statusBadge(consumer.statusDisplay)}
          </div>

          <div className="flex flex-wrap gap-4 text-sm text-gray-600 mt-1">
            <span className="flex items-center gap-1">
              <strong>Account No:</strong> {consumer.consumerNo}
            </span>
            <span className="flex items-center gap-1">
              <Mail className="w-4 h-4" />
              {consumer.email}
            </span>
            <span className="flex items-center gap-1">
              <Phone className="w-4 h-4" />
              {consumer.contactNumber}
            </span>
            <span className="font-medium">
              Credit: {currency} {consumer.creditBalance}
            </span>
          </div>
        </div>

        {/* Remove Button */}
        <Button
          onClick={onRemove}
          className="flex-shrink-0 p-1 hover:bg-gray-200 rounded transition-colors"
          title="Remove consumer"
          variant="outline"
        >
          <X className="w-5 h-5 text-gray-500" />
        </Button>
      </div>
    </div>
  );
};
